import ListCard from "@/components/census/ListCard";
import ListSepsis from "@/components/census/ListSepsis";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: { ListCard, ListSepsis }
})
export default class CensusList extends Vue {
  @Prop(Array)
  patients!: Array<Patient>;

  @Prop(String)
  itemComponent!: string;

  @Getter("area", patientNamespace)
  area!: string;

  get census() {
    return this.patients
      .map(p => p.census)
      .filter(census => {
        return !census.roomEmpty;
      });
  }
}
